<template>
  <a-layout class="my-application-box">
    <a-card class="create-application" :bordered=false :loading="loading" :class="fromLocation==='msg'?'msg-create-application':''">
      <div slot="title" v-if="pageLayout.pageTitle">
        <a-icon v-if="fromLocation==='app'" style="cursor:pointer;" type="left-circle" @click="back" />
        <div>{{pageLayout.pageTitle}}</div>
        <span class="page-status " :class="{'page-status-yellow':params.status==='审批中','page-status-green':params.status==='审批通过'||params.status==='付款成功','page-status-red':params.status==='审批拒绝'||params.status==='付款失败','page-status-gray':params.status==='已撤回'}">{{params.status}}</span>
      </div>
      <div slot="extra" style="cursor:pointer" class="extra" v-if="pageLayout.functions">
        <span v-for="(item,index) in pageLayout.functions" :key="index" style="margin-left:17px;">
          <span class="extra-trigger" @click="bankReceiptPrint" v-if="item.action==='bank_return'">
            <a-icon style="cursor:pointer" slot="suffixIcon" :component="'SvgIcFile'" />银行电子回单
          </span>
          <span class="extra-trigger" @click="gatherModal.visible=true" v-if="item.action==='modify_receive'">
            <a-icon style="cursor:pointer" slot="suffixIcon" :component="'SvgIcEdit'" />修正收款信息
          </span>
          <span class="extra-trigger" @click="retreatModalVisible=true" v-if="item.action==='withdraw'">
            <a-icon style="cursor:pointer" slot="suffixIcon" :component="'SvgIcEnter'" />撤回
          </span>
          <span class="extra-trigger" @click="print" v-if="item.action==='print'">
            <a-icon style="cursor:pointer" slot="suffixIcon" :component="'SvgIcFile'" />打印
          </span>
          <span class="extra-trigger" @click="modify" v-if="item.action==='modify_form'">
            <a-icon style="cursor:pointer" slot="suffixIcon" :component="'SvgIcEdit'" />修改
          </span>
          <span class="extra-trigger" @click="copy" v-if="item.action==='copy'">
            <a-icon style="cursor:pointer" slot="suffixIcon" :component="'SvgIcCopy'" />复制
          </span>
        </span>
      </div>
      <div v-for="(layout,index) in pageLayout.contents" :key="index" v-if="!loading && loadedInfo">
        <common-form :ref="'commonForm'" :layout="layout" v-if="layout.type==='commonForm'" :params="layout.field && params[layout.field]?params[layout.field]:{}" :can-edit="canEdit"></common-form>
        <multi-form :ref="'multiForm'" :layout="layout" v-if="layout.type==='multiForm'" :params="layout.field && params[layout.field]?params[layout.field]:[]" :can-edit="canEdit"></multi-form>
        <summation :layout="layout" v-if="layout.type==='summation'" :params="params[layout.field]?params[layout.field]:{}" :all-params="params" :from-detail="true"></summation>
        <upload v-if="layout.type==='upload'" :layout="layout" :params="params[layout.field]?params[layout.field]:[]" :can-edit="canEdit"></upload>
        <a-divider/>
      </div>
      <approval-flow :params="approvalFlowInfo" :init-text="'审批流数据加载中...'" v-if="!loading && loadedInfo"></approval-flow>
      <div style="text-align:center" v-else>
        <a-spin tip="数据加载中..."></a-spin>
      </div>
      <a-row class="footer">
        <a-col :xs="24" :sm="4"></a-col>
        <a-col :xs="24" :sm="20">
          <a-button @click="visibleComment = true" style="width:120px;" v-if="!loading && loadedInfo">评论</a-button>
        </a-col>
      </a-row>
    </a-card>
    <form-modal :basic-modal="gatherModal" :form-layout="gatherInfoForm" :params="params.basicInfo?params.basicInfo:{}" @submit="gatherModalSubmit" @cancel="gatherModalCancel"></form-modal>
    <form-modal :basic-modal="backModal" :form-layout="backInfoFormModal" @submit="backModalSubmit" @cancel="backModalCancel"></form-modal>
    <a-modal :visible="retreatModalVisible" title="撤回" @ok="retreat" :confirm-loading="retreatLoading" @cancel="retreatModalVisible=false">
      <h4>你确定撤回付款申请吗？</h4>
    </a-modal>
    <comment-and-copy :visible="visibleComment" @cancel="visibleComment = false" @reload="reload"></comment-and-copy>
    <!-- <a-modal :visible="true" title="撤回" @ok="retreat" @cancel="retreatModalVisible=false">
      <iframe src='https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png' frameborder='0'></iframe>
    </a-modal> -->
  </a-layout>
</template>

<script>
import UUID from "uuidjs";
import SvgIcBackbtn from "../../assets/svg/ic-left-circle-o.svg";
import SvgIcFile from "../../assets/svg/ic-file-o.svg";
import SvgIcEdit from "../../assets/svg/ic-edit-o.svg";
import SvgIcCopy from "../../assets/svg/ic-copy-o.svg";
import SvgIcEnter from "../../assets/svg/ic-enter.svg";
import CommonForm from "../../components/CommonForm.vue";
import MultiForm from "../../components/MultiForm.vue";
import Summation from "../../components/Summation.vue";
import ApprovalFlow from "../../components/ApprovalFlow.vue";
import FormModal from "../../components/FormModal.vue";
import Upload from "../../components/Upload.vue";
import { setTimeout } from "timers";
import LayoutConfig from "../../utils/LayoutConfig.js";
import { layoutConfig } from "../../utils/mockData.js";
import {
  gatherInfoForm,
  backInfoFormModal
} from "../../data/formModalConfigs.js";
import {
  getLayoutDetailApi,
  getPaymentDetail,
  createPayment,
  approvalApplication,
  getDetailApprovalFlow,
  printUrl,
  getBlueWhaleKey,
  downloadBankElectron
} from "../../services/CommonService.js";
import { modifyPaymentInfo } from "../../services/MyApplicationListService.js";

export default {
  components: {
    SvgIcBackbtn,
    SvgIcFile,
    SvgIcEdit,
    SvgIcCopy,
    SvgIcEnter,
    CommonForm,
    MultiForm,
    Summation,
    ApprovalFlow,
    FormModal,
    Upload
  },
  data() {
    return {
      canEdit: false,
      retreatModalVisible: false,
      breadcrumb: [
        {
          label: "我的申请",
          path: ""
        }
      ],
      cardHeight: 0,
      applicationTitle: "发起付款申请",
      params: {
        init: true
      },
      loading: false,
      loadedInfo: false,
      pageLayout: {},
      gatherModal: {
        visible: false,
        title: "修正收款信息",
        okText: "确定",
        cancel: "取消",
        width: 650,
        formItemLayout: {
          labelCol: {
            xs: { span: 24 },
            sm: { span: 6 }
          },
          wrapperCol: {
            xs: { span: 24 },
            sm: { span: 16 }
          }
        }
      },
      backModal: {
        visible: false,
        title: "打回",
        contentTitle: "你确定拒绝付款申请吗",
        width: 560,
        formItemLayout: {
          layout: "vertical",
          labelCol: {
            xs: { span: 24 },
            sm: { span: 24 }
          },
          wrapperCol: {
            xs: { span: 24 },
            sm: { span: 24 }
          }
        }
      },
      gatherInfoForm: gatherInfoForm,
      backInfoFormModal: backInfoFormModal,
      approvalFlowInfo: [],
      fromLocation: undefined,
      retreatLoading: false,
      visibleComment: false
    };
  },

  created() {
    this.fromLocation =
      window.location.href.indexOf("fromLocation=msg") === -1 ? "app" : "msg";
    this.id = this.$route.query.id;
    this.fetchLayout();
    this.fetchApprovalFlow();
  },
  mounted() {
    this.getPaymentDetail();
  },

  computed: {},

  methods: {
    fetchLayout() {
      this.loading = true;
      getLayoutDetailApi({
        id: this.id,
        menu_type: 1,
        ding_msg_switch:
          window.location.href.indexOf("fromLocation=msg") !== -1 ? 1 : 0
      }).then(res => {
        if (res.status === "success") {
          this.pageLayout = res.data;
          this.loading = false;
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    getPaymentDetail() {
      this.loadedInfo = false;
      getPaymentDetail({ type: "detail", id: this.id, menu_type: 1 }).then(
        res => {
          if (res.status === "success") {
            this.params = Object.assign({}, this.params, res.data);
            this.loadedInfo = true;
          } else {
            this.$Message.error(res.message);
          }
        }
      );
    },
    fetchApprovalFlow() {
      getDetailApprovalFlow({ id: this.$route.query.id }).then(res => {
        if (res.status === "success") {
          res.data.forEach((item, index) => {
            this.$set(this.approvalFlowInfo, index, item);
          });
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    back() {
      this.$router.replace({
        name: "myApplicationList"
      });
    },
    gatherModalSubmit(e) {
      e.is_need_receipt === '是' ? e.is_need_receipt = '1' : e.is_need_receipt = '2'
      const params = {
        ...e,
        applyId: this.$route.query.id,
        applyType: 1
      };
      modifyPaymentInfo(params).then(res => {
        if (res.status === "success") {
          this.$Message.success("修改成功");
          this.gatherModal.visible = false;
          this.getPaymentDetail();
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    gatherModalCancel() {
      this.gatherModal.visible = false;
    },
    backModalSubmit(e) {
      this.backModal.visible = false;
    },
    backModalCancel() {
      this.backModal.visible = false;
    },
    retreat() {
      let params = {
        applyId: this.$route.query.id,
        applyType: 1,
        status: 4
      };
      this.retreatLoading = true;
      approvalApplication(params).then(res => {
        if (res.status === "success") {
          this.retreatModalVisible = false;
          this.$Message.success("撤回成功");
          this.back();
        } else {
          this.$Message.error(res.message);
        }
        this.retreatLoading = false;
      });
    },
    print() {
      const accessToken = localStorage.getItem("accessToken");
      location.href = `${window.location.origin}/api/oa/payment/pdf/${
        this.$route.query.id
      }?accessToken=${accessToken}`;
      // this.axios.get(`${printUrl}${this.$route.query.id}`).then(res => {
      //   if (res.status === 'success') {
      //     this.$Message.success(res.data);
      //   } else {
      //     this.$Message.error(res.message);
      //   }
      // });
    },
    copy() {
      this.$router.replace({
        name: "createApplication",
        query: {
          id: this.$route.query.id,
          type: "create"
        }
      });
    },
    modify() {
      this.$router.replace({
        name: "myApplicationDetailEdit",
        query: {
          id: this.$route.query.id,
          type: "create"
        }
      });
    },
    bankReceiptPrint() {
      getBlueWhaleKey({ applyId: this.id }).then(res => {
        if (res.status === "success") {
          if (res.data) {
            res.data.forEach(item => {
              var iframe = document.createElement("iframe");
              iframe.style.display = "none";
              iframe.style.height = 0;
              iframe.src = `${
                window.location.origin
              }/api/oa/download-bank-electron?blueWhaleKey=${item.id}&name=${
                item.name
              }`;
              document.body.appendChild(iframe);
              setTimeout(() => {
                iframe.remove();
              }, 3 * 60 * 1000);
              // location.href = `${
              //   window.location.origin
              // }/api/oa/download-bank-electron?blueWhaleKey=${item}`;
            });
          }
        } else {
          this.$Message.error(res.massage);
        }
      });
    },

    reload() {
      this.visibleComment = false;
      this.fetchApprovalFlow();
    }
  }
};
</script>

<style lang="less">
.my-application-box {
  padding: 16px;
}
</style>
